import { getInternalApiKey, getOdooInternalApiKey } from "@/lib/env";

/**
 * Get Odoo bearer token from environment variable
 * @param required - If true, throws error when token is not set. Default: false
 * @returns The bearer token or empty string if not required and not set
 */
export const getOdooToken = (required: boolean = false): string => {
  const rawToken = getOdooInternalApiKey();
  if (required && !rawToken) {
    throw new Error("ODOO_INTERNAL_API_KEY environment variable is not configured");
  }
  return rawToken ? `Bearer ${rawToken}` : "";
};

/**
 * Get Meet API bearer token from environment variable
 * Server-side only - do not expose to client
 * @param required - If true, throws error when token is not set. Default: false
 * @returns The bearer token or empty string if not required and not set
 */
export const getMeetToken = (required: boolean = false): string => {
  const rawToken = getInternalApiKey();
  if (required && !rawToken) {
    throw new Error("INTERNAL_API_KEY environment variable is not configured");
  }
  return rawToken ? `Bearer ${rawToken}` : "";
};
